<template>
  <div v-if="show" :class="['ui-notice', `ui-notice--${variant}`, `ui-notice--border--${variant}`, { 'ui-notice--dense': dense }, customClass, 'p-1']">
    <feather-icon v-if="icon" :class="customIcon ? customIcon : `text-${variant}`" :icon="icon" :size="size"/>
    <div class="ui-notice__content">
      <slot>
        <span v-if="message">{{ message }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiNotice',
  props: {
    show: { type: Boolean, default: true },
    variant: { type: String, default: 'info' }, // info|success|warning|danger
    icon: { type: String, default: 'InfoIcon' },
    message: { type: String, default: '' },
    size: { type: [Number, String], default: '22' },
    dense: { type: Boolean, default: false },
    customClass: { type: String, default: '' },
    customIcon: { type: String, default: '' }
  }
}
</script>

<style scoped>
.ui-notice { display:flex; align-items:flex-start; gap:.5rem; padding:.5rem .75rem; border-radius:10px; }
.ui-notice__icon--info { color: rgba(1, 105, 222, 1) }
.ui-notice--info { background:rgba(230, 239, 250, 1); color:rgba(110, 107, 123, 1) }
.ui-notice--border--info { border:1px solid rgba(185, 213, 244, 1); }
</style>
